export const PERMISSIONS = {
  CAN_ACCESS_PREDICTIONS_ENGINE: 'can_access_predictions_engine',
  CAN_SAVE_PREDICTIONS: 'can_save_predictions',
  CAN_SEE_DETAILED_PREDICTIONS: 'can_see_detailed_predictions',
  CAN_ACCESS_SIMILARITY_TOOL: 'can_access_similarity_tool',
  CAN_ACCESS_ADJUSTABLE_SIMILARITY: 'can_access_adjustable_similarity',
  CAN_DOWNLOAD_ALL_DATA: 'can_download_all_data',
  CAN_MANAGE_ORGANIZATION_USERS: 'can_manage_organization_users',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export interface UserProfile {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  preferred_2fa_method: 'email' | 'sms';
  is_phone_number_verified: boolean;
  organization: {
    id: string;
    name: string;
    total_seats: number | null;
    total_seats_used: number;
  };
  is_superb_user: boolean;
  is_predictions_engine_enabled: boolean;
  is_domestic_models_access_allowed: boolean;
  role: {
    name: string;
    permissions: Permission[];
  };
}
